import { useEffect, useState } from 'react'
import { Modal } from 'components'
import ErrorMessage from 'components/forms/error-message'
import { lang } from 'config'
import _ from 'lodash'
import { Plus } from 'components/icons/outline'
import axios from 'axios'
import { toast } from 'react-hot-toast'
import nProgress from 'nprogress'
import Label from 'components/forms/label'
import SelectDescription from 'components/forms/select-description'
import useSWR from 'swr'
import useProductUnitRepositories from 'repositories/product-unit'
import SelectSearchable from 'components/forms/select-searchable'

const fetcher = async (url, params) => {
    return await axios.get(url, { params }).then((res) => res.data.data)
}

const Content = ({ data, onSubmit }) => {
    const { data: targetSelection, isLoading: isLoadingTargetSelection } = useSWR([`${process.env.REACT_APP_INVENTORY_API_URL}/product/${data?.level}`, { paginate: false }], fetcher)
    const { data: productUnitSelection, isLoading: isLoadingProductUnitSelection } = useProductUnitRepositories({
        paginate: false
    })

    const [productUnit, setProductUnit] = useState()
    const [productUnitId, setProductUnitId] = useState()

    const [errors, setErrors] = useState({})

    useEffect(() => {
        if (productUnitId && !isLoadingProductUnitSelection) {
            setProductUnit(productUnitSelection?.find((row) => row.id === productUnitId))
        }
    }, [productUnitId, isLoadingProductUnitSelection])

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!nProgress.isStarted()) {
            nProgress.start()

            nProgress.done()

            if (!productUnitId) {
                return toast.error("Invalid provided data.")
            }

            onSubmit(productUnit)
        } else {
            toast.error("Previous action is loading")
        }
    }

    return (
        <div className="mt-8 space-y-8">
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <Label htmlFor="product_unit" value="Product Unit" />
                        <SelectSearchable multiple filter={(value) => value.long_name} onChange={(value) => setProductUnit(value)} selection={productUnitSelection} isLoading={isLoadingProductUnitSelection} value={productUnit} keyValue={(value) => value.id} title={(value) => value.name} description={(value) => value.long_name} placeholder="Select Product Unit" error={errors.product_units} />
                        <ErrorMessage error={errors.product_unit} />
                    </div>
                </div>
            </div>
            <div className="text-xs">
                <button onClick={handleSubmit} className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{lang.save}</span>
                </button>
            </div>
        </div>
    )
}

const Add = ({ data, onSubmit }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSubmit = (data) => {
        onSubmit(data)

        closeModal()
    }

    return (
        <>
            <button type="button" onClick={openModal} className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90">
                <Plus className="w-4 h-4" stroke={1.5} />
                <span>{lang.create}</span>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.create} ${lang.data}`} content={<Content data={data} onSubmit={handleSubmit} />} />
        </>
    )
}

export default Add